module.exports = __webpack_public_path__ + "img/home-icon.a8c8b027.svg";